import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuerySample } from '@store/helpers';

export const companyLicensesApi = createApi({
  reducerPath: 'CompanyLicenses',
  tagTypes: ['CompanyLicenses'],
  baseQuery: baseQuerySample,
  endpoints: (builder) => ({
    getCompanyLicensesTableData: builder.mutation({
      query: ({
        page,
        size,
        body = {},
        params = { sortBy: 'expirationDate', sortDir: 'desc' },
      }) => ({
        url: `/v1/contractors/permit/contractor?page=${page}&size=${size}`,
        method: 'POST',
        body,
        params,
      }),
    }),
    getCompanyLicensesById: builder.query({
      query: ({ id }) => ({
        url: `/v1/contractors/permit/${id}`,
      }),
    }),
    createOrUpdateCompanyLicenses: builder.mutation({
      query: ({ id, body, method }) => ({
        url: `/v1/contractors/permit/${id ? `update/${id}` : 'create'}`,
        method,
        body,
      }),
    }),
  }),
});

export const {
  useGetCompanyLicensesTableDataMutation,
  useLazyGetCompanyLicensesByIdQuery,
  useCreateOrUpdateCompanyLicensesMutation,
} = companyLicensesApi;
